export default __webpack_public_path__ + "static/media/yellow_icon.7021b3ed.svg";